module.exports = __webpack_public_path__ + "static/media/rocbaby.20748c14.gif";